/* DMC global helpers: (1) quantity selector in the same row as Add to cart, (2) warehouse stock line under the SKU,
   (3) MiniShops menu dropdown in the search banner, (4) WhatsApp support button on the MiniShop setup page, (5) MoreTyme fee sync. */
(function () {
  function placeStock(info) {
    var s = document.querySelector('.dmc-stock');
    if (!s) return;
    var data = null;
    try {
      data = JSON.parse(s.getAttribute('data-stock'));
    } catch (e) {
      return;
    }
    var anchor = info.querySelector('.product__sku');
    if (anchor && anchor.nextElementSibling !== s) anchor.parentNode.insertBefore(s, anchor.nextSibling);
    var input = info.querySelector('.product-variant-id') || info.querySelector('form [name=id]');
    var vid = input ? input.value : null;
    var n = vid != null ? data[vid] : undefined;
    if (n == null) {
      s.hidden = true;
      return;
    }
    n = Math.max(0, parseInt(n, 10) || 0);
    s.querySelector('.dmc-stock__n').textContent = n;
    s.classList.toggle('is-out', n <= 0);
    s.hidden = false;
  }

  function place() {
    document.querySelectorAll('product-info').forEach(function (info) {
      var q = info.querySelector('.product-form__quantity');
      var b = info.querySelector('.product-form__buttons');
      if (q && b && q.parentNode !== b) {
        b.classList.add('dmc-buy-row');
        b.insertBefore(q, b.firstChild);
      }
      placeStock(info);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      place();
    });
  }

  function start() {
    place();
    document.querySelectorAll('product-info').forEach(function (info) {
      new MutationObserver(schedule).observe(info, { childList: true, subtree: true });
      info.addEventListener('change', schedule);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* MiniShops dropdown in the search banner + WhatsApp support on the MiniShop setup page */
(function () {
  var WA_NUMBER = '27715255803';
  var css =
    '.dmc-mm{position:fixed;z-index:100002;min-width:260px;max-width:calc(100vw - 24px);background:#fff;border:1px solid #d7e0ee;border-radius:14px;box-shadow:0 14px 40px rgba(15,23,42,.18);padding:6px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif}' +
    '.dmc-mm[hidden]{display:none}' +
    '.dmc-mm a{display:flex;align-items:center;gap:12px;padding:10px 12px;border-radius:10px;text-decoration:none;color:#0f172a}' +
    '.dmc-mm a:hover,.dmc-mm a:focus{background:#eef3fc;outline:none}' +
    '.dmc-mm .dmc-mm-ic{width:34px;height:34px;border-radius:10px;background:#e8eefb;display:flex;align-items:center;justify-content:center;font-size:17px;flex-shrink:0}' +
    '.dmc-mm b{display:block;font-size:14px;font-weight:700;color:#002366;line-height:1.25}' +
    '.dmc-mm small{display:block;font-size:12px;color:#64748b;line-height:1.3;margin-top:1px}' +
    '.sn-menu__link.dmc-has-menu::after{content:"";display:inline-block;margin-left:6px;width:6px;height:6px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg) translateY(-2px)}' +
    '.ms-hero-side{grid-area:badge;justify-self:end;display:flex;align-items:center;gap:10px;flex-wrap:wrap;justify-content:flex-end}' +
    '.ms-hero-side .ms-hero-badge{margin:0}' +
    '.ms-wa-support{display:inline-flex;align-items:center;gap:8px;padding:9px 18px;border-radius:50px;background:#25d366;color:#06301a;font-size:13px;font-weight:700;text-decoration:none;white-space:nowrap;box-shadow:0 4px 14px rgba(37,211,102,.35);transition:transform .15s,filter .15s}' +
    '.ms-wa-support:hover{transform:translateY(-1px);filter:brightness(1.06);color:#06301a}' +
    '@media(max-width:640px){.ms-hero-side{grid-area:auto;grid-column:1/-1;justify-self:start;justify-content:flex-start;margin-top:10px}}';

  function addStyle() {
    if (document.getElementById('dmc-extras-css')) return;
    var st = document.createElement('style');
    st.id = 'dmc-extras-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function miniShopMenu() {
    var link = document.querySelector('.sn-wrap .sn-menu__link[href*="minishop-guide"]');
    if (!link || link.getAttribute('data-dmc-menu')) return;
    link.setAttribute('data-dmc-menu', '1');
    link.classList.add('dmc-has-menu');
    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');

    var menu = document.createElement('div');
    menu.className = 'dmc-mm';
    menu.hidden = true;
    menu.setAttribute('role', 'menu');
    menu.innerHTML =
      '<a role="menuitem" href="/pages/minishop-guide"><span class="dmc-mm-ic">&#128214;</span><span><b>How to create</b><small>Step-by-step MiniShop guide</small></span></a>' +
      '<a role="menuitem" href="/pages/create-minishop"><span class="dmc-mm-ic">&#9999;&#65039;</span><span><b>Create or update</b><small>Set up or change your shop</small></span></a>' +
      '<a role="menuitem" href="/pages/minishop-dashboard"><span class="dmc-mm-ic">&#128230;</span><span><b>MiniShop dashboard</b><small>Your orders and shop overview</small></span></a>';
    document.body.appendChild(menu);

    function close() {
      menu.hidden = true;
      link.setAttribute('aria-expanded', 'false');
    }
    function open() {
      var r = link.getBoundingClientRect();
      menu.hidden = false;
      var w = menu.offsetWidth;
      var left = Math.min(Math.max(12, r.left + r.width / 2 - w / 2), window.innerWidth - w - 12);
      menu.style.left = left + 'px';
      menu.style.top = r.bottom + 8 + 'px';
      link.setAttribute('aria-expanded', 'true');
    }
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (menu.hidden) open();
      else close();
    });
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !menu.contains(e.target) && !link.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    window.addEventListener('scroll', close, { passive: true });
    window.addEventListener('resize', close);
  }

  function waSupport() {
    var inner = document.querySelector('.ms-wrap .ms-hero-inner');
    if (!inner || inner.querySelector('.ms-wa-support')) return;
    var side = document.createElement('div');
    side.className = 'ms-hero-side';
    var badge = inner.querySelector('.ms-hero-badge');
    if (badge) side.appendChild(badge);
    var a = document.createElement('a');
    a.className = 'ms-wa-support';
    a.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent('Hi DMC, I need help with my MiniShop');
    a.target = '_blank';
    a.rel = 'noopener';
    a.innerHTML = '&#128172; WhatsApp support';
    side.appendChild(a);
    inner.appendChild(side);
  }

  function init() {
    addStyle();
    miniShopMenu();
    waSupport();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* MoreTyme fee: R2 + 5% of the cart value (excluding the fee line itself), charged as a R1 product x quantity.
   The automatic wholesale discount also reduces the fee line, so the quantity is scaled up by the discount
   Shopify actually applies to that line (measured from the cart, default 20%) so the customer pays the correct net fee.
   Added when cart attribute Payment = MoreTyme, removed otherwise, and recalculated whenever the cart changes. */
(function () {
  var HANDLE = 'moretyme-fee-r2-5';
  var VARIANT_ID = 67515345076452;
  var FLAT_CENTS = 200;
  var PERCENT = 0.05;
  var DEFAULT_RATIO = 0.8;
  var running = null;
  var timer = null;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function baseCents(cart) {
    var total = 0;
    cart.items.forEach(function (i) {
      if (i.handle !== HANDLE) total += i.final_line_price;
    });
    return total;
  }

  /* Net fee the customer should pay, in whole rand. */
  function feeRand(cart) {
    var base = baseCents(cart);
    if (base <= 0) return 0;
    return Math.ceil((FLAT_CENTS + base * PERCENT) / 100);
  }

  function findFee(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === HANDLE) return cart.items[i];
    }
    return null;
  }

  /* Share of the list price the customer pays on the fee line after automatic discounts. */
  function ratioFor(fee) {
    if (fee && fee.original_line_price > 0) {
      var r = fee.final_line_price / fee.original_line_price;
      if (r > 0.05 && r <= 1) return r;
    }
    return DEFAULT_RATIO;
  }

  function refreshUI() {
    if (location.pathname === '/cart') {
      location.reload();
      return;
    }
    var cd = document.querySelector('cart-drawer');
    if (cd && cd.classList.contains('active') && cd.getSectionsToRender) {
      var ids = cd.getSectionsToRender().map(function (s) {
        return s.id;
      });
      fetch('/?sections=' + ids.join(','))
        .then(function (r) {
          return r.json();
        })
        .then(function (sections) {
          cd.renderContents({ sections: sections });
        })
        .catch(function () {});
    }
  }

  /* One pass. Resolves to true when the cart was changed. */
  function runSync() {
    return getCart().then(function (cart) {
      var pay = cart.attributes && cart.attributes.Payment;
      var fee = findFee(cart);
      var net = pay === 'MoreTyme' ? feeRand(cart) : 0;
      var want = net > 0 ? Math.ceil(net / ratioFor(fee) - 1e-9) : 0;
      var changed = false;
      var chain = Promise.resolve();

      if (want === 0 && fee) {
        chain = post('/cart/change.js', { id: fee.key, quantity: 0 });
        changed = true;
      } else if (want > 0 && !fee) {
        chain = post('/cart/add.js', { items: [{ id: VARIANT_ID, quantity: want, properties: { _payment_fee: 'MoreTyme' } }] });
        changed = true;
      } else if (want > 0 && fee && fee.quantity !== want) {
        chain = post('/cart/change.js', { id: fee.key, quantity: want });
        changed = true;
      }

      return chain
        .then(function () {
          var feeText = net > 0 ? 'R' + net.toFixed(2) : '';
          if ((cart.attributes && cart.attributes['Payment Fee'] || '') !== feeText) {
            return post('/cart/update.js', { attributes: { 'Payment Fee': feeText } });
          }
        })
        .then(function () {
          return changed;
        });
    });
  }

  /* Repeats up to 3 times so the quantity settles once Shopify reports the real discount on the fee line. */
  function loop(n, anyChange) {
    return runSync().then(function (changed) {
      if (changed && n < 3) return loop(n + 1, true);
      if (changed || anyChange) refreshUI();
    });
  }

  function sync() {
    if (running) return running;
    running = loop(1, false)
      .catch(function (e) {
        console.error('MoreTyme fee sync failed', e);
      })
      .then(function () {
        running = null;
      });
    return running;
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 600);
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (!running && (u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1)) {
        p.then(scheduleSync, function () {});
      }
    } catch (e) {}
    return p;
  };

  window.DMCFee = { sync: sync, getCart: getCart, feeRand: feeRand, baseCents: baseCents };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
